import $ from "jquery";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export default class StandoutStats {
  $el = $("section.standout-stats");

  constructor() {
    if (!this.$el.length) return;

    gsap.registerPlugin(ScrollTrigger);

    this.init();
  }

  init() {
    if (window.innerWidth >= 768) {
      //this.animateIn();
    }
    this.counter();
  }

  animateIn() {
    const $left = this.$el.find(".stat-0");
    const $right = this.$el.find(".stat-1");

    gsap.from($left, {
      x: "-=300",
      duration: 1,
      scrollTrigger: {
        trigger: $left[0],
        start: "top bottom",
        end: "80% bottom",
        toggleActions: "play none none none",
        markers: false,
        scrub: 1,
      },
    });

    gsap.from($right, {
      x: "+=300",
      duration: 1,
      scrollTrigger: {
        trigger: $right[0],
        start: "top bottom",
        end: "80% bottom",
        toggleActions: "play none none none",
        markers: false,
        scrub: 1,
      },
    });
  }

  counter() {
    const $counter = this.$el.find(".number-wrapper");

    $counter.each(function () {
      const $this = $(this);
      const countTo = $this.data("count-to");

      gsap.from($this, {
        scale: 0,
        ease: "back.out(3)",
        duration: 0.5,
        scrollTrigger: {
          trigger: $this[0],
          start: "top 80%",
          end: "bottom 10%",
          toggleActions: "play none none none",
          markers: false,
        },
      });
    });
  }
}
